import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const LogoWrapper = styled.div`
  display: inline-flex;
  align-items: center;

  a {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
  }
`;

const Logo = () => (
  <LogoWrapper>
    <Link to="/" aria-label="Prodseal home">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 168 40"
        fill="none"
        height="34"
        width="auto"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="logo-icon-g" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#615DFF"/>
            <stop offset="100%" stopColor="#3DD9EB"/>
          </linearGradient>
          <linearGradient id="logo-text-g" x1="48" y1="0" x2="168" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#615DFF"/>
            <stop offset="100%" stopColor="#3DD9EB"/>
          </linearGradient>
        </defs>
        {/* Shield */}
        <path d="M20 3L34 9V21C34 29 27 35.5 20 37.5C13 35.5 6 29 6 21V9Z" fill="url(#logo-icon-g)"/>
        <path d="M20 7L30 12V21C30 27 25 32 20 33.5" stroke="white" strokeWidth="0.8" opacity="0.25" fill="none"/>
        <path d="M13 20.5L17.5 25L27 14.5" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        {/* Divider */}
        <line x1="46" y1="10" x2="46" y2="30" stroke="#615DFF" strokeWidth="1" opacity="0.3"/>
        {/* Wordmark */}
        <text
          x="54" y="27"
          fontFamily="-apple-system,BlinkMacSystemFont,'Inter','Segoe UI',sans-serif"
          fontWeight="700" fontSize="22" letterSpacing="-0.5"
          fill="url(#logo-text-g)"
        >
          Prodseal
        </text>
      </svg>
    </Link>
  </LogoWrapper>
);

export default Logo;
